import { View, StyleSheet, ViewStyle } from "react-native";
import { Text } from "react-native-paper";
import React from "react";

export const DisplayTextRow = ({
  label,
  value,
  children,
  containerStyle,
}: {
  label?: string;
  value?: string;
  children?: React.ReactNode;
  containerStyle?: ViewStyle;
}) => {
  const renderedChildren = React.isValidElement(children)
    ? React.cloneElement(children as any, {
        style: StyleSheet.flatten([(children as any).props?.style, styles.valueText]),
      })
    : children;

  return (
    <View style={[styles.row, containerStyle]}>
      <View style={styles.labelContainer}>
        <Text style={styles.label}>{label ? label + ":" : label}</Text>
      </View>
      <View style={styles.valueContainer}>
        {children ? (
          renderedChildren
        ) : (
          <Text style={[styles.bold, styles.valueText]}>{value}</Text>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  labelContainer: {
    flexShrink: 0,
    maxWidth: "40%",
    paddingRight: 10,
  },
  valueContainer: {
    flex: 1,
    minWidth: 0,
    alignItems: "flex-end",
  },
  valueText: {
    textAlign: "right",
    alignSelf: "stretch",
  },
  label: {
    color: "#555555",
  },
  bold: {
    fontWeight: "bold",
  },
});
